<template>
  <div class="contract-form">
    <div class="breadcrumb">
      <i class="fa fa-home"></i> Estás en:
      <router-link :to="{name: 'contracts'}">Revisiones</router-link>/ Nueva hospitalización
    </div>
    <div class="wrapper-form clearfix">
      <div class="form-title">
        <div class="text-bold">
          <i class="fas fa-edit u-black-light"></i> Hospitalización
        </div>
      </div>
      <div class="form-wrapper">
        <div class="form-group">
          <!-- <label class="form-label">Nombre del paciente</label>
          <patient-input :wallet.sync="patient.wallet" @update-name="patient.name = $event" :pub.sync="patientPUB"></patient-input> -->
          <label class="form-label"> Identidad del paciente</label>
          <userlist :wallet.sync="patient.wallet" @update-name="patient.name = $event" :pub.sync="patientPUB"></userlist>
        </div>
        <div class="form-group">
          <label class="form-label">Razón</label>
          <input class="form-input" v-model="patient.reason" />
        </div>
        <div class="form-group">
          <label class="form-label">Fecha</label>
          <date-time type="datetime" v-model="date" />
        </div>
        <div class="form-group" v-for="field in fields" v-bind:key="field.property">
          <label class="form-label">{{field.translation}}</label>

          <textarea
            class="form-input"
            v-if="field.type == 'textarea'"
            v-model="externalProperties[field.property]"
          ></textarea>
          <input
            v-if="field.type == 'text'"
            class="form-input"
            v-model="externalProperties[field.property]"
          />
        </div>
        <!-- <div class="form-group">
          <label class="form-label">Médico</label>
          <medic-input :medic="patient.medic" @update="patient.medic= $event"></medic-input>
        </div>-->

        <file-input :files="files" @update="files = $event"></file-input>
        <button type="button" class="btn btn-primary mt-2 float-right" v-on:click="send">Enviar</button>
      </div>
    </div>
  </div>
</template>


<script>
import VisitsManager from "../managers/visitsManager";
import FileInput from "./file-input";
import IpfsManager from "../managers/IpfsManager";
import fileFields from "../config/contractFields.json";
// import MedicInput from "./medic-input";
// import PatientInput from "./patients-input";
import Swal from "sweetalert2";
import { Datetime } from "vue-datetime";
import Gun from 'gun'
const sea = Gun.SEA
import gun from '../managers/gun'
import userlist from './userlist'
export default {
  components: {
    FileInput,
    // MedicInput,
    // PatientInput,
    "date-time": Datetime,
    userlist
  },
  data() {
    return {
      patient: {
        wallet: "",
        reason: ""
      },
      date: null,
      fields: fileFields,
      externalProperties: {},
      files: [],
      patientPUB: ""
    };
  },
  methods: {
    send() {
      Swal.fire({
        title: "¿Estás seguro?",
        showCancelButton: true,
        confirmButtonText: "Sí",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.deploy();
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then(result => {
        if (result.value) {
          Swal.fire({
            title: `¡Creado!`
          });

          this.$router.push({ name: "mi-registro" });
        }
      });
    },
    async deploy() {
      console.log(this.patient);
      var sendedID = [];
      var external = [];
      var result = await IpfsManager.SendFile(this.files);

      result.forEach(element => {
        sendedID.push({ fileHash: element.path, name: element.path });
      });
      var patientKeys = await gun.user(this.patientPUB)
      var secret = await sea.secret(patientKeys.epub, gun.user()._.sea)
      for (let field of this.fields) {
        let fieldData = this.externalProperties[field.property]
        if(fieldData != null) {
        var encryptedData = await sea.encrypt(fieldData, secret)
        result = await IpfsManager.SendFile(
          Buffer.from(encryptedData)
        );
        external.push({ fileHash: result[0].path, name: field.property });
        }

      }
      console.log("upload")
      this.patient.pub = this.patientPUB
      debugger
      await VisitsManager.CreateHospitalization(
        this.patient,
        sendedID,
        external,
        new Date(this.date).getTime(),
        gun.user()._.sea.pub
      );

    }
  },
  async created() {}
};
</script>